"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = exports.INIT_COORDS = void 0;
const INIT_COORDS = 'dnd-core/INIT_COORDS';
exports.INIT_COORDS = INIT_COORDS;
const BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
exports.BEGIN_DRAG = BEGIN_DRAG;
const PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
exports.PUBLISH_DRAG_SOURCE = PUBLISH_DRAG_SOURCE;
const HOVER = 'dnd-core/HOVER';
exports.HOVER = HOVER;
const DROP = 'dnd-core/DROP';
exports.DROP = DROP;
const END_DRAG = 'dnd-core/END_DRAG';
exports.END_DRAG = END_DRAG;

//# sourceMappingURL=types.js.map